// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--cc-btn-primary-bg:#4caf50!important}.cc-add-links{display:flex;margin-top:10px}.cc-add-links .cc-link,.cc-add-links a{display:inline-block;font-weight:500;margin-right:15px!important}", ""]);
// Exports
module.exports = exports;
